import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

import { colors } from '../../../utils/kpiUtils'

const KpiBarchartTooltip = props => {
  const { active, showTotal, payload = [], label, labelSuffix } = props
  if (!active || isEmpty(payload)) {
    return null
  }
  return (
    <div className="kpi-tooltip box-element">
      <p className="bold">{`${label} ${labelSuffix || ''}`}</p>
      <hr />
      {payload.map(data => (
        <div className="item-list" key={data.name}>
          {data.color && (
            <div
              className="inline"
              style={{
                backgroundColor: data.color,
                border: `2px ${colors.grey} solid`,
                borderRadius: '5px',
                marginRight: '3px',
                height: '10px',
                width: '10px'
              }}
            />
          )}
          <div className="inline">
            <span className="bold"> {data.name}: </span>
            {data.value ? `${data.value}${data.unit || ''}` : 0}
          </div>
        </div>
      ))}
      {showTotal === true ? (
        <div>
          <hr />
          <p>
            <span className="bold">Total:</span> {payload[0].payload.total}
          </p>{' '}
        </div>
      ) : null}
    </div>
  )
}

KpiBarchartTooltip.propTypes = {
  type: PropTypes.string,
  payload: PropTypes.array,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  active: PropTypes.bool,
  showTotal: PropTypes.bool,
  productColors: PropTypes.object,
  labelSuffix: PropTypes.string
}

export default KpiBarchartTooltip
